/* eslint-disable @typescript-eslint/no-explicit-any */
import { encodeQueryParams } from './encodeQueryParams';

interface IQueryParams {
  search?: string;
  limit?: number;
  page?: number;
  bypass?: boolean;
  filters?: Record<string, any>;
  sort?: Record<string, any>;
}

const DEFAULT_LIMIT = 50;
const DEFAULT_PAGE = 1;

export const createQueryString = (params: IQueryParams): string => {
  const { search = '', limit = DEFAULT_LIMIT, page = DEFAULT_PAGE, bypass, filters, sort } = params;

  const queryParams: Record<string, string> = {
    page: page.toString(),
    search
  };

  if (!bypass) {
    queryParams['limit'] = limit.toString();
  }

  let queryString = new URLSearchParams(queryParams).toString();

  const filtersArray = Object.entries(filters ?? {}).filter(([_, value]) => value !== undefined);
  if (filtersArray.length > 0)
    queryString += `&${encodeQueryParams(Object.fromEntries(filtersArray))}`;
  if (sort) queryString += `&${encodeQueryParams(sort)}`;

  return queryString;
};
